import { EntityDefinition } from '@/types/crud';
import { TENANT_STATUS_OPTIONS, DEFAULT_STATUS_VALUES } from '@/types/enums';

export const tenantEntity: EntityDefinition = {
  name: 'tenant',
  displayName: 'Tenants',
  displayNameSingular: 'Tenant',
  apiEndpoint: '/tenants',
  fields: [
    {
      key: 'name',
      label: 'tenantManagement.companyName',
      type: 'text',
      required: true,
      placeholder: 'tenantManagement.enterCompanyName',
      validation: {
        minLength: 2,
        maxLength: 100
      }
    },
    {
      key: 'domain',
      label: 'tenantManagement.domain',
      type: 'text',
      required: false,
      placeholder: 'tenantManagement.enterDomainOptional',
      helpText: 'tenantManagement.domainCannotBeChanged',
      validation: {
        maxLength: 255
      },
      // Domain is read-only when editing existing tenant
      readOnly: (isEditing: boolean) => isEditing
    },
    {
      key: 'status',
      label: 'tenantManagement.status',
      type: 'select',
      required: true,
      options: TENANT_STATUS_OPTIONS,
      defaultValue: DEFAULT_STATUS_VALUES.TENANT
    },
    {
      key: 'tenant_admins',
      label: 'tenantManagement.tenantAdmins',
      type: 'textarea',
      required: false,
      placeholder: 'tenantManagement.noAdministratorsFound',
      helpText: 'tenantManagement.listOfAdmins',
      readOnly: true,
      rows: 3,
      fullWidth: true
    },
    {
      key: 'created_at',
      label: 'tenantManagement.dateCreated',
      type: 'date',
      required: false,
      helpText: 'tenantManagement.tenantCreationDate',
      readOnly: true
    }
  ],
  tableColumns: [
    { key: 'name', label: 'tenantManagement.companyName', sortable: true },
    { key: 'domain', label: 'tenantManagement.domain', sortable: true },
    { key: 'status', label: 'tenantManagement.status', sortable: true },
    { key: 'user_count', label: 'tenantManagement.totalUsers', sortable: true },
    { key: 'admin_count', label: 'tenantManagement.tenantAdmins', sortable: true },
    { key: 'created_at', label: 'tenantManagement.dateCreated', sortable: true }
  ],
  searchFields: ['name', 'domain'],
  defaultSort: { field: 'name', direction: 'asc' }
}; 